var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgStepbystep = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 284,
    height: 284,
    viewBox: "0 0 284 284",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M142.8 143.9C141.8 143.9 140.7 143.7 139.8 143.2L71.8 109.2C69.5 108 68 105.7 68 103.1C68 100.5 69.5 98.2 71.8 97L139.8 63C141.7 62 144 62 145.9 63L213.9 97C216.2 98.2 217.7 100.5 217.7 103.1C217.7 105.7 216.2 108 213.9 109.2L145.9 143.2C144.9 143.7 143.8 143.9 142.8 143.9ZM90 103.1L142.8 129.5L195.6 103.1L142.8 76.7L90 103.1Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M142.8 211.9C141.8 211.9 140.7 211.7 139.8 211.2L71.8001 177.2C68.4001 175.5 67.1001 171.4 68.8001 168.1C70.5001 164.7 74.6001 163.4 77.9001 165.1L142.9 197.6L207.9 165.1C211.3 163.4 215.3 164.8 217 168.1C218.7 171.5 217.3 175.5 214 177.2L146 211.2C144.9 211.7 143.8 211.9 142.8 211.9Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M142.8 177.9C141.8 177.9 140.7 177.7 139.8 177.2L71.8001 143.2C68.4001 141.5 67.1001 137.4 68.8001 134.1C70.5001 130.7 74.6001 129.4 77.9001 131.1L142.9 163.6L207.9 131.1C211.3 129.4 215.3 130.8 217 134.1C218.7 137.5 217.3 141.5 214 143.2L146 177.2C144.9 177.7 143.8 177.9 142.8 177.9Z",
    fill: "black"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgStepbystep, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/stepbystep.26581e5b.svg";
export { ForwardRef as ReactComponent };